import React from 'react';
import '../../sass/RowsRule.scss';

let RowCheckbox =  ({ onChangeRow, rule, displayCheckbox, isTitle, hasDay }) => {

    return (

        <div key={rule.Id}>
            <div className="row rule">
                <div className={displayCheckbox ? "col-md-9" : "col-md-12"}>
                    <div className={`row ${isTitle && `rule-title`}`}>
                        <div className="col-md-12">
                            {rule.Descripcion}
                            {
                                (rule.Informacion.length > 0) &&
                                <a data-toggle="collapse" href={`#collapseRule${rule.Id}`}
                                    role="button" aria-expanded="false" aria-controls={`#collapseRule${rule.Id}`}>
                                    <small> Más Información</small>
                                </a>
                            }
                        </div>
                    </div>
                </div>
                {
                    (displayCheckbox) &&
                    <div className="col-md-3 price">
                        <div className="row">
                            <div className="col-md-9">Q{rule.Precio} {hasDay && "por día"}</div>
                            <div className="col-md-3 ">
                                <label className="container-checkmarkbox">
                                    <input id={rule.Id} type="checkbox" onChange={onChangeRow} checked={rule.Seleccionado} />
                                    <span className="checkmarkbox"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className="row line">
                <div className="col-md-12"><hr /></div>
            </div>
            {
                (rule.Informacion) &&
                <div className="row collapse multi-collapse" id={`collapseRule${rule.Id}`} >
                    <div className="col-md-12" >
                        {
                            rule.Informacion.map((info, index) =>
                                <div key={`info-${rule.Id}-${index}`} className="row">
                                    <div className="col-md-12">
                                        <div className="row rule-title-info">
                                            <div className="col-md-12">{(info.Titulo) ? info.Titulo : info.Subtitulo}</div>
                                        </div>
                                        <div className="row rule-text-info">
                                            <div className="col-md-12">{info.Parrafo}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default RowCheckbox;